import { FC } from 'react';

import PartnerOperationsTableHeader from './PartnerOpertionsTableHeader';
import PartnerOperationsTableBody from './PartnerOperationsTableBody';

const PartnerOperationsTable: FC = () => (
  <div className="card card-bordered card-preview">
    <table className="table table-striped">
      <PartnerOperationsTableHeader />

      <PartnerOperationsTableBody />
    </table>
  </div>
);

export default PartnerOperationsTable;
